export default class Articolo{

    CodiceArticolo;
    DescrizioneArticolo;
    UnitaMisura;
    CheckMagazzino;

}